// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Fondo ── */
#bg {
  background-image: url('fondoemail.jpg');
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
}

.content-wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
}

/* ── Tarjeta ── */
.success-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 36px;
  max-width: 460px;
  width: 100%;
  text-align: center;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.35);
  animation: slideUp 0.5s ease;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ── Logo ── */
.logo-wrapper {
  margin: 0 auto 16px;
  width: 72px;
  height: 72px;
}

.logo-img {
  border-radius: 50%;
  border: 3px solid rgba(208, 29, 23, 0.25);
  display: block;
  width: 72px;
  height: 72px;
}

/* ── Spinner (consistente con pagorespuesta3ds2) ── */
.spinner-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
}

.spinner {
  width: 80px;
  height: 80px;
  animation: rotateSpin 1.4s linear infinite;
}

.spinner-track {
  stroke: #e8e8e8;
}

.spinner-arc {
  stroke: #d01d17;
  stroke-linecap: round;
  stroke-dasharray: 80;
  stroke-dashoffset: 60;
  animation: dashSpin 1.4s ease-in-out infinite;
}

@keyframes rotateSpin {
  to { transform: rotate(360deg); }
}

@keyframes dashSpin {
  0%   { stroke-dashoffset: 120; }
  50%  { stroke-dashoffset: 30; }
  100% { stroke-dashoffset: 120; }
}

/* ── Checkmark animado ── */
.check-circle {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
}

.checkmark {
  width: 80px;
  height: 80px;
}

.checkmark-circle {
  stroke: #d01d17;
  stroke-width: 2;
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  animation: strokeCircle 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark-check {
  stroke: #d01d17;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: strokeCheck 0.4s 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

@keyframes strokeCircle {
  to { stroke-dashoffset: 0; }
}

@keyframes strokeCheck {
  to { stroke-dashoffset: 0; }
}

/* ── Textos ── */
.title {
  font-size: 1.8rem;
  font-weight: 800;
  color: #391410;
  margin: 0 0 6px;
}

.subtitle {
  font-size: 0.95rem;
  color: #666;
  margin: 0 0 20px;
}

/* ── Divisor ── */
.divider {
  height: 3px;
  background: linear-gradient(90deg, #d01d17, #391410);
  border-radius: 4px;
  margin: 0 auto 20px;
  width: 60px;
}

/* ── Caja de mensaje ── */
.message-box {
  background: #fff8f8;
  border: 1px solid #f5c5c5;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  text-align: left;
}

.message-icon {
  font-size: 1.4rem;
  flex-shrink: 0;
}

.message-text {
  font-size: 0.88rem;
  color: #444;
  margin: 0;
  line-height: 1.6;
}

/* ── Filas de info ── */
.info-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.85rem;
  color: #555;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f9f9f9;
  margin-bottom: 8px;
  text-align: left;
}

.info-icon {
  font-size: 1.1rem;
  flex-shrink: 0;
}

/* ── Botón ticket ── */
.btn-ticket {
  margin-top: 20px;
  width: 100%;
  padding: 13px;
  background: #391410;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.5px;
  transition: background 0.2s;
}

.btn-ticket:hover:not(:disabled) {
  background: #5a2018;
}

.btn-ticket:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ── Botón cerrar ── */
.btn-close-page {
  margin-top: 10px;
  width: 100%;
  padding: 13px;
  background: #d01d17;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.5px;
  transition: background 0.2s;
}

.btn-close-page:hover:not(:disabled) {
  background: #391410;
}

.btn-close-page:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ── Responsive ── */
@media (max-width: 500px) {
  .success-card { padding: 28px 20px; }
  .title { font-size: 1.5rem; }
}

/* ════════════════════════════════════════
   TICKET PDF — div oculto fuera de pantalla
   ════════════════════════════════════════ */
.ticket-pdf-wrapper {
  position: absolute;
  left: -9999px;
  top: 0;
  width: 400px;
  background: #ffffff;
  font-family: Helvetica, Arial, sans-serif;
  padding: 0;
}

.ticket-header {
  background: #1a0a08;
  padding: 28px 20px 20px;
  text-align: center;
}

.ticket-logo {
  border-radius: 50%;
  border: 3px solid rgba(255,255,255,0.4);
  display: block;
  margin: 0 auto 12px;
}

.ticket-brand {
  color: #ffffff;
  font-size: 18px;
  font-weight: 800;
  margin: 0 0 4px;
  letter-spacing: 1px;
}

.ticket-brand-sub {
  color: rgba(255,255,255,0.6);
  font-size: 11px;
  margin: 0;
}

.ticket-body {
  padding: 24px 20px;
  background: #ffffff;
}

.ticket-divider {
  height: 3px;
  background: linear-gradient(90deg, #d01d17, #391410);
  border-radius: 4px;
  width: 60px;
  margin: 0 auto 16px;
}

.ticket-section-title {
  text-align: center;
  font-size: 13px;
  font-weight: 800;
  color: #391410;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0 0 16px;
}

.ticket-qr {
  text-align: center;
  margin-bottom: 20px;
}

.ticket-productos {
  margin-bottom: 4px;
}

.ticket-producto-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 5px 12px;
  background: #f9f9f9;
  border-radius: 6px;
  margin-bottom: 4px;
  font-size: 13px;
}

.ticket-producto-qty {
  color: #d01d17;
  font-weight: 800;
  font-size: 12px;
  flex-shrink: 0;
  min-width: 24px;
}

.ticket-producto-nombre {
  color: #391410;
  font-weight: 600;
  flex: 1;
}

.ticket-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 12px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 6px;
  font-size: 13px;
}

.ticket-label {
  color: #888888;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex-shrink: 0;
  margin-right: 10px;
}

.ticket-value {
  color: #391410;
  font-weight: bold;
  text-align: right;
  font-size: 13px;
}

.ticket-value.red   { color: #d01d17; }
.ticket-value.orange { color: #e97a0d; }

.ticket-sep {
  border-top: 1px solid #eeeeee;
  margin: 16px 0;
}

.ticket-total-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #666666;
  padding: 5px 0;
}

.ticket-total-row span:last-child {
  font-weight: bold;
  color: #391410;
}

.ticket-total-row.total {
  border-top: 2px solid #391410;
  padding-top: 10px;
  margin-top: 4px;
  font-size: 16px;
  font-weight: 900;
  color: #391410;
}

.ticket-total-row.total span:last-child {
  color: #d01d17;
  font-weight: 900;
}

.ticket-notice {
  margin-top: 16px;
  background: #fff5f5;
  border-left: 4px solid #d01d17;
  border-radius: 8px;
  padding: 12px;
  font-size: 12px;
  color: #666666;
  line-height: 1.6;
}

.ticket-notice strong {
  color: #d01d17;
}

.ticket-footer {
  background: #1a0a08;
  text-align: center;
  padding: 14px;
  font-size: 11px;
  color: rgba(255,255,255,0.6);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/pagoexitoso/pagoexitoso.component.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,uCAA8D;EAC9D,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,sBAAsB,EAAE;EAC/B,OAAO,qBAAqB,EAAE;EAC9B,OAAO,sBAAsB,EAAE;AACjC;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,wEAAwE;AAC1E;;AAEA;EACE,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,KAAK,oBAAoB,EAAE;AAC7B;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,oDAAoD;EACpD,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB,kBAAkB,EAAE;EACpC,SAAS,iBAAiB,EAAE;AAC9B;;AAEA;;6CAE6C;AAC7C;EACE,kBAAkB;EAClB,aAAa;EACb,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oDAAoD;EACpD,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,sBAAsB,cAAc,EAAE;AACtC,uBAAuB,cAAc,EAAE;;AAEvC;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,4BAA4B;AAC9B","sourcesContent":["/* ── Fondo ── */\n#bg {\n  background-image: url('../../../assets/images/fondoemail.jpg');\n  min-height: 100vh;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n}\n\n.content-wrapper {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 24px 16px;\n}\n\n/* ── Tarjeta ── */\n.success-card {\n  background: #fff;\n  border-radius: 16px;\n  padding: 40px 36px;\n  max-width: 460px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.35);\n  animation: slideUp 0.5s ease;\n}\n\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(30px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* ── Logo ── */\n.logo-wrapper {\n  margin: 0 auto 16px;\n  width: 72px;\n  height: 72px;\n}\n\n.logo-img {\n  border-radius: 50%;\n  border: 3px solid rgba(208, 29, 23, 0.25);\n  display: block;\n  width: 72px;\n  height: 72px;\n}\n\n/* ── Spinner (consistente con pagorespuesta3ds2) ── */\n.spinner-wrapper {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 20px;\n}\n\n.spinner {\n  width: 80px;\n  height: 80px;\n  animation: rotateSpin 1.4s linear infinite;\n}\n\n.spinner-track {\n  stroke: #e8e8e8;\n}\n\n.spinner-arc {\n  stroke: #d01d17;\n  stroke-linecap: round;\n  stroke-dasharray: 80;\n  stroke-dashoffset: 60;\n  animation: dashSpin 1.4s ease-in-out infinite;\n}\n\n@keyframes rotateSpin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes dashSpin {\n  0%   { stroke-dashoffset: 120; }\n  50%  { stroke-dashoffset: 30; }\n  100% { stroke-dashoffset: 120; }\n}\n\n/* ── Checkmark animado ── */\n.check-circle {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 20px;\n}\n\n.checkmark {\n  width: 80px;\n  height: 80px;\n}\n\n.checkmark-circle {\n  stroke: #d01d17;\n  stroke-width: 2;\n  stroke-dasharray: 166;\n  stroke-dashoffset: 166;\n  animation: strokeCircle 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;\n}\n\n.checkmark-check {\n  stroke: #d01d17;\n  stroke-width: 3;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-dasharray: 48;\n  stroke-dashoffset: 48;\n  animation: strokeCheck 0.4s 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;\n}\n\n@keyframes strokeCircle {\n  to { stroke-dashoffset: 0; }\n}\n\n@keyframes strokeCheck {\n  to { stroke-dashoffset: 0; }\n}\n\n/* ── Textos ── */\n.title {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: #391410;\n  margin: 0 0 6px;\n}\n\n.subtitle {\n  font-size: 0.95rem;\n  color: #666;\n  margin: 0 0 20px;\n}\n\n/* ── Divisor ── */\n.divider {\n  height: 3px;\n  background: linear-gradient(90deg, #d01d17, #391410);\n  border-radius: 4px;\n  margin: 0 auto 20px;\n  width: 60px;\n}\n\n/* ── Caja de mensaje ── */\n.message-box {\n  background: #fff8f8;\n  border: 1px solid #f5c5c5;\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  text-align: left;\n}\n\n.message-icon {\n  font-size: 1.4rem;\n  flex-shrink: 0;\n}\n\n.message-text {\n  font-size: 0.88rem;\n  color: #444;\n  margin: 0;\n  line-height: 1.6;\n}\n\n/* ── Filas de info ── */\n.info-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.85rem;\n  color: #555;\n  padding: 8px 12px;\n  border-radius: 8px;\n  background: #f9f9f9;\n  margin-bottom: 8px;\n  text-align: left;\n}\n\n.info-icon {\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n\n/* ── Botón ticket ── */\n.btn-ticket {\n  margin-top: 20px;\n  width: 100%;\n  padding: 13px;\n  background: #391410;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  cursor: pointer;\n  letter-spacing: 0.5px;\n  transition: background 0.2s;\n}\n\n.btn-ticket:hover:not(:disabled) {\n  background: #5a2018;\n}\n\n.btn-ticket:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ── Botón cerrar ── */\n.btn-close-page {\n  margin-top: 10px;\n  width: 100%;\n  padding: 13px;\n  background: #d01d17;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  cursor: pointer;\n  letter-spacing: 0.5px;\n  transition: background 0.2s;\n}\n\n.btn-close-page:hover:not(:disabled) {\n  background: #391410;\n}\n\n.btn-close-page:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ── Responsive ── */\n@media (max-width: 500px) {\n  .success-card { padding: 28px 20px; }\n  .title { font-size: 1.5rem; }\n}\n\n/* ════════════════════════════════════════\n   TICKET PDF — div oculto fuera de pantalla\n   ════════════════════════════════════════ */\n.ticket-pdf-wrapper {\n  position: absolute;\n  left: -9999px;\n  top: 0;\n  width: 400px;\n  background: #ffffff;\n  font-family: Helvetica, Arial, sans-serif;\n  padding: 0;\n}\n\n.ticket-header {\n  background: #1a0a08;\n  padding: 28px 20px 20px;\n  text-align: center;\n}\n\n.ticket-logo {\n  border-radius: 50%;\n  border: 3px solid rgba(255,255,255,0.4);\n  display: block;\n  margin: 0 auto 12px;\n}\n\n.ticket-brand {\n  color: #ffffff;\n  font-size: 18px;\n  font-weight: 800;\n  margin: 0 0 4px;\n  letter-spacing: 1px;\n}\n\n.ticket-brand-sub {\n  color: rgba(255,255,255,0.6);\n  font-size: 11px;\n  margin: 0;\n}\n\n.ticket-body {\n  padding: 24px 20px;\n  background: #ffffff;\n}\n\n.ticket-divider {\n  height: 3px;\n  background: linear-gradient(90deg, #d01d17, #391410);\n  border-radius: 4px;\n  width: 60px;\n  margin: 0 auto 16px;\n}\n\n.ticket-section-title {\n  text-align: center;\n  font-size: 13px;\n  font-weight: 800;\n  color: #391410;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin: 0 0 16px;\n}\n\n.ticket-qr {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.ticket-productos {\n  margin-bottom: 4px;\n}\n\n.ticket-producto-row {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  padding: 5px 12px;\n  background: #f9f9f9;\n  border-radius: 6px;\n  margin-bottom: 4px;\n  font-size: 13px;\n}\n\n.ticket-producto-qty {\n  color: #d01d17;\n  font-weight: 800;\n  font-size: 12px;\n  flex-shrink: 0;\n  min-width: 24px;\n}\n\n.ticket-producto-nombre {\n  color: #391410;\n  font-weight: 600;\n  flex: 1;\n}\n\n.ticket-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 8px 12px;\n  background: #f9f9f9;\n  border-radius: 8px;\n  margin-bottom: 6px;\n  font-size: 13px;\n}\n\n.ticket-label {\n  color: #888888;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  flex-shrink: 0;\n  margin-right: 10px;\n}\n\n.ticket-value {\n  color: #391410;\n  font-weight: bold;\n  text-align: right;\n  font-size: 13px;\n}\n\n.ticket-value.red   { color: #d01d17; }\n.ticket-value.orange { color: #e97a0d; }\n\n.ticket-sep {\n  border-top: 1px solid #eeeeee;\n  margin: 16px 0;\n}\n\n.ticket-total-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  color: #666666;\n  padding: 5px 0;\n}\n\n.ticket-total-row span:last-child {\n  font-weight: bold;\n  color: #391410;\n}\n\n.ticket-total-row.total {\n  border-top: 2px solid #391410;\n  padding-top: 10px;\n  margin-top: 4px;\n  font-size: 16px;\n  font-weight: 900;\n  color: #391410;\n}\n\n.ticket-total-row.total span:last-child {\n  color: #d01d17;\n  font-weight: 900;\n}\n\n.ticket-notice {\n  margin-top: 16px;\n  background: #fff5f5;\n  border-left: 4px solid #d01d17;\n  border-radius: 8px;\n  padding: 12px;\n  font-size: 12px;\n  color: #666666;\n  line-height: 1.6;\n}\n\n.ticket-notice strong {\n  color: #d01d17;\n}\n\n.ticket-footer {\n  background: #1a0a08;\n  text-align: center;\n  padding: 14px;\n  font-size: 11px;\n  color: rgba(255,255,255,0.6);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
